import {
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  MenuItem,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import Constants from "../common/constants";
import withServices from "../hocs/withServices";
import FileUpload from "./utils/FileUpload";
import Loader from "./utils/Loader";
import { makeStyles } from "@material-ui/core/styles";

const statuses = [
  {
    id: 1,
    label: "Платное отделение",
  },
  {
    id: 2,
    label: "Государственный грант",
  },
];

function ExamRegistration({ services }) {
  const checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== "") {
        return true;
      }

      return false;
    }
  };
  const useStyles = makeStyles((theme) => ({
    root: {
      // '& .MuiFormControl-root': {
      //   width: '80%',
      //   margin: theme.spacing(1)
      // }
    },
    pageContent: {
      [theme.breakpoints.up("sm")]: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
      },
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(0),
        padding: theme.spacing(1),
      },
    },
    txtField: {
      [theme.breakpoints.down("xs")]: {
        paddingTop: "25px",
      },
    },
    englishCertificate: {
      [theme.breakpoints.down("xs")]: {
        paddingTop: "50px",
      },
    },
  }));
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [isApproved, setIsApproved] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [academicDegrees, setAcademicDegrees] = useState([]);
  const [educationalPrograms, setEducationalPrograms] = useState([]);
  const [additionalCourses, setAdditionalCourses] = useState([]);
  const [financingPrograms, setFinancingPrograms] = useState([]);
  const [financialSources, setFinancialSources] = useState([]);
  const [educationalProgramGroup, setEducationalProgramGroup] = useState([]);
  const [examTypes, setExamTypes] = useState([]);
  const [examLanguages, setExamLanguages] = useState([]);
  // combinedExams: [],
  const [englishCertificateTypes, setEnglishCertificateTypes] = useState([]);
  const [olympiadCertificateTypes, setOlympiadCertificateTypes] = useState([]);
  const [quotas, setQuotas] = useState([]);
  const [selectedAcademicDegree, setSelectedAcademicDegree] = useState("");
  const [selectedStudyStatus, setSelectedStudyStatus] = useState("");
  const [selectedEducationalProgram, setSelectedEducationalProgram] =
    useState("");
  const [selectedAdditionalCourse, setSelectedAdditionalCourse] =
    useState("");
  const [selectedFinancingProgram, setSelectedFinancingProgram] = useState("");
  const [selectedFinancialSource, setSelectedFinancialSource] =
    useState("");
  const [selectedCombinedExam, setSelectedCombinedExam] = useState();
  const [selectedExamType, setSelectedExamType] = useState("");
  const [selectedExamLanguage, setSelectedExamLanguage] = useState("");
  const [selectedEnglishCertificateType, setSelectedEnglishCertificateType] =
    useState("");
  const [selectedOlympiadCertificateType, setSelectedOlympiadCertificateType] =
    useState("");
  const [selectedQuota, setSelectedQuota] = useState("");
  const [individualTestingCode, setIndividualTestingCode] = useState();
  const [entDetails, setEntDetails] = useState({});
  const [creativeExamPoint, setCreativeExamPoint] = useState();

  const [entCertificateScan, setEntCertificateScan] = useState();
  const [englishExamScan, setEnglishExamScan] = useState();
  const [olympiadCertificateScan, setOlympiadCertificateScan] = useState();

  const [entCertificateScanPath, setEntCertificateScanPath] = useState();
  const [englishExamScanPath, setEnglishExamScanPath] = useState();
  const [olympiadCertificateScanPath, setOlympiadCertificateScanPath] =
    useState();

  const [grantCertificateScan, setGrantCertificateScan] = useState();
  const [grantCertificatePath, setGrantCertificatePath] = useState();
  const [grantDetails, setGrantDetails] = useState({});

  const [aetEnglishPoint, setAetEnglishPoint] = useState(undefined);
  const [aetIctPoint, setAetIctPoint] = useState(undefined);
  const [examMark, setExamMark] = useState(0);

  const [paymentReceiptScan, setPaymentReceiptScan] = useState();
  const [paymentReceiptPath, setPaymentReceiptPath] = useState();
  const [paymentAmount, setPaymentAmount] = useState();

  const [englishCertificatePoints, setEnglishCertificatePoints] = useState();

  const fetchData = async () => {
    services.admissionInfo.getAcademicDegrees().then((response) => {
      setAcademicDegrees(response.data);
    });
    services.admissionInfo.getExamTypes().then((response) => {
      setExamTypes(response.data);
    });
    services.admissionInfo.getQuota().then((response) => {
      setQuotas(response.data);
    });
    services.admissionInfo.getExamLanguages().then((response) => {
      setExamLanguages(response.data);
    });
    services.admissionInfo
      .getEnglishCertificateTypes()
      .then((response) => {
        setEnglishCertificateTypes(response.data);
      });
    services.admissionInfo
      .getOlympiadCertificateTypes()
      .then((response) => {
        setOlympiadCertificateTypes(response.data);
      });
    services.secretary
      .checkConfirm(services.auth.getCurrentUser().id)
      .then((response) => {
        setIsApproved(response.data);
      });
    services.admissionInfo
      .getDuEducationalPrograms(1)
      .then((response) => {
        setEducationalPrograms(response.data);
      });
    services.admissionInfo
      .getAdditionalCourses()
      .then((response) => {
        setAdditionalCourses(response.data);
      });
    services.admissionInfo
      .getFinancingPrograms()
      .then((response) => {
        setFinancingPrograms(response.data);
      });

    services.admissionInfo.getSelected().then((response) => {
      if (response?.data) {
        const { data } = response;
        setSelectedEducationalProgram(data.educationalProgram?.duId);
        setSelectedAdditionalCourse(data.additionalCourse?.id);
        setSelectedFinancingProgram(data.financingProgram?.id);
        setSelectedFinancialSource(data.financialSource?.id);
        setSelectedAcademicDegree(data.academicDegree?.id);
        setEducationalProgramGroup(
          data.educationalProgram?.educationalProgramGroup
        );
        setSelectedExamType(data.examType?.id);
        setSelectedExamLanguage(data.examLanguage?.id);
        setSelectedEnglishCertificateType(data.englishCertificateType?.id);
        setSelectedOlympiadCertificateType(data.olympiadCertificateType?.id);
        setSelectedQuota(data.quota?.id);
        setIndividualTestingCode(data.ikt);
        setEntDetails(data.entDetailsDtoResponse);
        setCreativeExamPoint(data.creativeExamPoints);
        setEntCertificateScan(data.entCertificate?.id);
        setEnglishExamScan(data.englishCertificate?.id);
        setOlympiadCertificateScan(data.olympiadCertificate?.id);
        setEnglishCertificatePoints(data.englishCertificatePoints);
        // Path (путь) загружаемых документов (entCertificateScan и englishExamScan)
        setEntCertificateScanPath(data.entCertificate?.path);
        setEnglishExamScanPath(data.englishCertificate?.path);
        setOlympiadCertificateScanPath(data.olympiadCertificate?.path);

        setSelectedStudyStatus(data.studyType);

        setGrantDetails({
          grantNumber: data.grantNumber,
          grantIssueDate: data.grantIssueDate,
        });
        setGrantCertificateScan(data.grantCertificate?.id);
        setGrantCertificatePath(data.grantCertificate?.path);
        setAetEnglishPoint(data.aetEnglishPoint);
        setAetIctPoint(data.aetICTPoint);
        setExamMark(data.examMark);

        setPaymentAmount(data.paymentAmount);
        setPaymentReceiptScan(data.paymentReceiptScan?.id);
        setPaymentReceiptPath(data.paymentReceiptScan?.path);
      }
    });
  };

  useEffect(() => {
    fetchData();

    setLoading(false);
  }, []);

  useEffect(() => {
    if (
      selectedAcademicDegree !== null &&
      selectedAcademicDegree !== undefined &&
      selectedAcademicDegree !== ""
    ) {
      services.admissionInfo
        .getDuEducationalPrograms(selectedAcademicDegree)
        .then((response) => {
          setEducationalPrograms(response.data);
        });
    }
  }, [selectedAcademicDegree]);

  useEffect(() => {
    if (
      selectedStudyStatus !== null &&
      selectedStudyStatus !== undefined &&
      selectedStudyStatus !== ""
    ) {
      services.admissionInfo
        .getFinancingSources(selectedStudyStatus)
        .then((response) => {
          setFinancialSources(response.data);
        });
    }
  }, [selectedStudyStatus]);

  useEffect(() => {
    if (
      selectedEducationalProgram !== null &&
      selectedEducationalProgram !== undefined &&
      selectedEducationalProgram !== ""
    ) {
      services.admissionInfo
        .getEducationalProgramGroupByDuId(selectedEducationalProgram)
        .then((response) => {
          setEducationalProgramGroup(response.data);
        });
    }
  }, [selectedEducationalProgram]);


  const isCertificateValid = (certificateType, points) => {
    switch (certificateType) {
      case 1: // IELTS
        return points >= 6.5;
      case 2: // TOEFL IBT
        return points >= 79;
      case 3: // TOEFL PBT
        return points >= 548;
      default:
        return false;
    }
  };


  const handleSubmit = () => {
    const data = {
      englishCertificatePoints: englishCertificatePoints || null,
      academicDegree: selectedAcademicDegree || null,
      educationalProgram: selectedEducationalProgram || null,
      additionalCourseId: selectedAdditionalCourse || null,
      financingProgramId: selectedFinancingProgram || null,
      financingSourceId: selectedFinancialSource || null,
      examType: selectedExamType || null,
      examLanguage: selectedExamLanguage || null,
      quotaId: selectedQuota || null,
      englishCertificateType: selectedEnglishCertificateType || null,
      englishCertificateId: englishExamScan || null,
      olympiadCertificateType: selectedOlympiadCertificateType || null,
      olympiadCertificateId: olympiadCertificateScan || null,
      entCertificateId: entCertificateScan || null,
      ikt: individualTestingCode || null,
      examMark: examMark || null,
      ...(checkProperties(entDetails) && {
        entDetails: {
          mathematicalLiteracyPoint:
            entDetails?.mathematicalLiteracyPoint || null,
          readingLiteracyPoint: entDetails?.readingLiteracyPoint || null,
          kazakhstanHistoryPoint: entDetails?.kazakhstanHistoryPoint || null,
          profileSubject1Point: entDetails?.profileSubject1Point || null,
          profileSubject2Point: entDetails?.profileSubject2Point || null,
        },
      }),
      creativeExamPoints: creativeExamPoint || null,
      studyType: selectedStudyStatus || null,
      ...(selectedStudyStatus === 1 && {
        paymentReceiptScanId: paymentReceiptScan || null,
        paymentAmount: paymentAmount || null,
      }),
      ...(selectedStudyStatus === 2 && {
        grantCertificateId: grantCertificateScan || null,
        grantIssueDate: grantDetails?.grantIssueDate || null,
        grantNumber: grantDetails?.grantNumber || null,
      }),
    };
    services.admissionInfo
      .postAdmissionInfo(data)
      .then(() => {
        alert("Ваши данные успешно сохранены");
        setErrorMessage(null);
      })
      .catch((error) => {
        setErrorMessage("Произошла ошибка при обработке запроса");
        alert("Не удалось сохранить данные");
      });
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Paper className={classes.pageContent}>
            <form className={classes.root}>
              <Typography variant="h5">Сведения о поступлении</Typography>
              <br></br>
              <Grid
                container
                justify="center"
                /* style={{ marginTop: '30px' }} */ spacing={3}
              >
                {isApproved && (
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6">
                      Вы не можете ничего менять, так как ваши данные уже
                      подтверждены
                    </Typography>
                  </Grid>
                )}
                {/* <Box>
                  <TextField
                    fullWidth
                    value={aetEnglishPoint}
                    variant="outlined"
                    label="Выберите нужную вам академическую степень"
                    className={classes.txtField}
                  />
                </Box> */}

                <Grid item xs={12} md={8} lg={10}>
                  {(aetEnglishPoint || aetIctPoint) && (
                    <Alert severity="success">
                      <AlertTitle>Результаты АЕТ</AlertTitle>
                      {aetEnglishPoint && (
                        <Typography>
                          Баллы за английский язык - {aetEnglishPoint}
                        </Typography>
                      )}
                      {aetIctPoint && (
                        <Typography>Баллы за ИКТ - {aetIctPoint}</Typography>
                      )}
                    </Alert>
                  )}
                </Grid>
                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    fullWidth
                    select
                    value={selectedAcademicDegree}
                    variant="outlined"
                    label="Выберите нужную вам академическую степень"
                    className={classes.txtField}
                    onChange={(e) => setSelectedAcademicDegree(e.target.value)}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {academicDegrees.map((academicDegree) => (
                      <MenuItem
                        key={academicDegree.id}
                        value={academicDegree.id}
                      >
                        {academicDegree.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {selectedAcademicDegree && (
                  <>
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        fullWidth
                        select
                        variant="outlined"
                        label="Выберите образовательную программу"
                        className={classes.txtField}
                        onChange={(e) =>
                          setSelectedEducationalProgram(e.target.value)
                        }
                        value={selectedEducationalProgram}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {educationalPrograms.map((educationalProgram) => (
                          <MenuItem
                            key={educationalProgram.id}
                            value={educationalProgram.id}
                          >
                            {educationalProgram.titleEn}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </>
                )}

                {/* <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    fullWidth
                    select
                    variant="outlined"
                    label="Программа финансирования"
                    className={classes.txtField}
                    onChange={(e) =>
                      setSelectedFinancingProgram(e.target.value)
                    }
                    value={selectedFinancingProgram}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {financingPrograms.map((financingProgram) => (
                      <MenuItem
                        key={financingProgram.id}
                        value={financingProgram.id}
                      >
                        {financingProgram.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}

                {selectedEducationalProgram && (
                  <Grid item xs={12} md={8} lg={10}>
                    <TextField
                      fullWidth
                      select
                      variant="outlined"
                      label="Выберите вид экзамена"
                      onChange={(e) => setSelectedExamType(e.target.value)}
                      value={selectedExamType}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>
                      {examTypes.map((examType) => {
                        if (
                          selectedAcademicDegree === 2 &&
                          examType.name.includes("ЕНТ")
                        ) {
                          return null;
                        }
                        if (
                          selectedAcademicDegree === 2 &&
                          examType.name.includes("Собеседование")
                        ) {
                          return null;
                        }
                        if (
                          selectedAcademicDegree === 2 &&
                          examType.name.includes("ЕНТ ТиПО")
                        ) {
                          return null;
                        }
                        if (
                          selectedAcademicDegree === 1 &&
                          examType.name.includes("Комплексное тестирование")
                        ) {
                          return null;
                        }

                        return (
                          <MenuItem key={examType.id} value={examType.id}>
                            {examType.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                )}

                {selectedExamType && (
                  <Grid item xs={12} md={8} lg={10}>
                    <TextField
                      fullWidth
                      select
                      variant="outlined"
                      label="Выберите язык экзамена"
                      onChange={(e) => setSelectedExamLanguage(e.target.value)}
                      disabled={selectedExamType === 2}
                      value={selectedExamType === 2 ? 3 : selectedExamLanguage}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>
                      {examLanguages.map((examLanguage) => {
                        return (
                          <MenuItem
                            key={examLanguage.id}
                            value={examLanguage.id}
                          >
                            {examLanguage.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                )}

                {selectedEducationalProgram &&
                  (selectedExamType === 1 ||
                    selectedExamType === 4 ||
                    selectedExamType === 3) &&
                  (selectedAcademicDegree === 1 ||
                    selectedAcademicDegree === 2) &&
                  selectedEducationalProgram !== 4 && (
                    <>
                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="ИКТ (Индивидуальный Код Тестируемого)"
                          className={classes.txtField}
                          onChange={(e) =>
                            setIndividualTestingCode(e.target.value)
                          }
                          value={individualTestingCode}
                        />
                      </Grid>
                    </>
                  )}

                {selectedEducationalProgram &&
                  selectedExamType === 1 &&
                  selectedAcademicDegree === 1 &&
                  selectedEducationalProgram !== 4 && (
                    <>
                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Ваши баллы за грамотность чтения"
                          className={classes.txtField}
                          onChange={(e) =>
                            setEntDetails((prevState) => ({
                              ...prevState,
                              readingLiteracyPoint: e.target.value,
                            }))
                          }
                          value={entDetails?.readingLiteracyPoint}
                        />
                      </Grid>
                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Ваши баллы за историю Казахстана"
                          className={classes.txtField}
                          onChange={(e) =>
                            setEntDetails((prevState) => ({
                              ...prevState,
                              kazakhstanHistoryPoint: e.target.value,
                            }))
                          }
                          value={entDetails?.kazakhstanHistoryPoint}
                        />
                      </Grid>
                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Ваши баллы за математическую грамотность"
                          className={classes.txtField}
                          onChange={(e) =>
                            setEntDetails((prevState) => ({
                              ...prevState,
                              mathematicalLiteracyPoint: e.target.value,
                            }))
                          }
                          value={entDetails?.mathematicalLiteracyPoint}
                        />
                      </Grid>
                      {selectedEducationalProgram !== null &&
                        selectedEducationalProgram !== undefined ? (
                        <>
                          <Grid item xs={12} md={8} lg={10}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              label={`Ваши баллы за предмет "${educationalProgramGroup?.subject1?.title}"`}
                              className={classes.txtField}
                              onChange={(e) =>
                                setEntDetails((prevState) => ({
                                  ...prevState,
                                  profileSubject1Point: e.target.value,
                                }))
                              }
                              value={entDetails?.profileSubject1Point}
                            />
                          </Grid>
                          <Grid item xs={12} md={8} lg={10}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              label={`Ваши баллы за предмет "${educationalProgramGroup?.subject2?.title}"`}
                              className={classes.txtField}
                              onChange={(e) =>
                                setEntDetails((prevState) => ({
                                  ...prevState,
                                  profileSubject2Point: e.target.value,
                                }))
                              }
                              value={entDetails?.profileSubject2Point}
                            />
                          </Grid>
                        </>
                      ) : null}

                      <Grid item xs={12} md={8} lg={10}>
                        <FileUpload
                          helperText="Сертификат ЕНТ (скан)"
                          fileType={Constants.FILE_TYPES.entCertificate}
                          file={entCertificateScan}
                          filePath={entCertificateScanPath}
                          handleSetFileId={(fileId) =>
                            setEntCertificateScan(fileId)
                          }
                          handleDelete={() => {
                            fetchData();
                          }}
                        />
                      </Grid>
                    </>
                  )}
                {selectedEducationalProgram &&
                  selectedExamType === 1 &&
                  selectedAcademicDegree === 1 &&
                  selectedEducationalProgram === 4 && (
                    <>
                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="ИКТ (Индивидуальный Код Тестируемого)"
                          onChange={(e) =>
                            setIndividualTestingCode(e.target.value)
                          }
                          value={individualTestingCode}
                        />
                      </Grid>

                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Ваши баллы за грамотность чтения"
                          onChange={(e) =>
                            setEntDetails((prevState) => ({
                              ...prevState,
                              readingLiteracyPoint: e.target.value,
                            }))
                          }
                          value={entDetails?.readingLiteracyPoint}
                        />
                      </Grid>

                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Ваши баллы за историю Казахстана"
                          onChange={(e) =>
                            setEntDetails((prevState) => ({
                              ...prevState,
                              kazakhstanHistoryPoint: e.target.value,
                            }))
                          }
                          value={entDetails?.kazakhstanHistoryPoint}
                        />
                      </Grid>

                      <Grid item xs={12} md={8} lg={10}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          label="Ваши баллы за творческий экзамен"
                          onChange={(e) =>
                            setCreativeExamPoint(e.target.value)
                          }
                          value={creativeExamPoint}
                        />
                      </Grid>

                      <Grid item xs={12} md={8} lg={10}>
                        <FileUpload
                          helperText="Сертификат ЕНТ (скан)"
                          fileType={Constants.FILE_TYPES.entCertificate}
                          file={entCertificateScan}
                          filePath={entCertificateScanPath}
                          handleSetFileId={(fileId) =>
                            setEntCertificateScan(fileId)
                          }
                          handleDelete={() => {
                            fetchData();
                          }}
                        />
                      </Grid>
                    </>
                  )}

                {selectedEducationalProgram &&
                  (selectedExamType != 2) && (
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        type={"number"}
                        label="Сумма баллов по результатам ЕНТ/КТ по профилю (общепрофильные предметы и профилирующие предметы)"
                        onChange={(e) => setExamMark(e.target.value)}
                        value={examMark}
                      />
                    </Grid>
                  )}

                {selectedExamType === 3 && (
                  <Grid item xs={12} md={8} lg={10}>
                    <FileUpload
                      helperText="Сертификат КТ"
                      fileType={Constants.FILE_TYPES.entCertificate}
                      file={entCertificateScan}
                      filePath={entCertificateScanPath}
                      handleSetFileId={(fileId) =>
                        setEntCertificateScan(fileId)
                      }
                      handleDelete={() => {
                        fetchData();
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    fullWidth
                    select
                    variant="outlined"
                    label="Обучение по квоте (смотреть в свидетельстве о гранте)"
                    onChange={(e) =>
                      setSelectedQuota(e.target.value)
                    }
                    value={selectedQuota}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {quotas.map((Quota) => {

                      return (
                        <MenuItem
                          key={Quota.id}
                          value={Quota.id}
                        >
                          {Quota.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>


                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    fullWidth
                    select
                    value={selectedStudyStatus}
                    variant="outlined"
                    label="Выберите вид обучения"
                    className={classes.txtField}
                    onChange={(e) => setSelectedStudyStatus(e.target.value)}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {statuses.map((status) => (
                      <MenuItem key={status.id} value={status.id}>
                        {status.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {selectedStudyStatus && (
                  <>
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        fullWidth
                        select
                        variant="outlined"
                        label="Вид финансирования"
                        className={classes.txtField}
                        onChange={(e) =>
                          setSelectedFinancialSource(e.target.value)
                        }
                        value={selectedFinancialSource}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {financialSources.map((financialSource) => (
                          <MenuItem
                            key={financialSource.id}
                            value={financialSource.id}
                          >
                            {financialSource.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </>
                )}

                {selectedStudyStatus === 2 && (
                  <>
                    <Grid item xs={12} md={8} lg={10}>
                      <FileUpload
                        helperText="Скан свидетельства о гранте после результатов гранта"
                        fileType={Constants.FILE_TYPES.grantCertificate}
                        file={grantCertificateScan}
                        filePath={grantCertificatePath}
                        handleSetFileId={(fileId) =>
                          setGrantCertificateScan(fileId)
                        }
                        handleDelete={() => {
                          fetchData();
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        label="Введите номер свидетельства о гранте"
                        onChange={(e) =>
                          setGrantDetails((prevState) => ({
                            ...prevState,
                            grantNumber: e.target.value,
                          }))
                        }
                        value={grantDetails?.grantNumber}
                      />
                    </Grid>
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        type="date"
                        value={grantDetails?.grantIssueDate}
                        helperText="Дата выдачи свидетельства о гранте"
                        onChange={(e) =>
                          setGrantDetails((prevState) => ({
                            ...prevState,
                            grantIssueDate: e.target.value,
                          }))
                        }
                      ></TextField>
                    </Grid>
                  </>
                )}

                {selectedStudyStatus === 1 && (
                  <>
                    <Grid item xs={12} md={8} lg={10}>
                      <FileUpload
                        helperText="Скан чека об оплате"
                        fileType={Constants.FILE_TYPES.paymentReceipt}
                        file={paymentReceiptScan}
                        filePath={paymentReceiptPath}
                        handleSetFileId={(fileId) =>
                          setPaymentReceiptScan(fileId)
                        }
                        handleDelete={() => {
                          fetchData();
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        label="Введите вносимую сумму"
                        onChange={(e) => setPaymentAmount(e.target.value)}
                        value={paymentAmount}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    fullWidth
                    select
                    variant="outlined"
                    label="Выберите имеющийся у вас тип экзамена для подтверждения знаний английского языка"
                    className={classes.englishCertificate}
                    onChange={(e) =>
                      setSelectedEnglishCertificateType(e.target.value)
                    }
                    value={selectedEnglishCertificateType}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {englishCertificateTypes.map((englishCertificateType) => {
                      if (
                        selectedAcademicDegree === 2 &&
                        englishCertificateType.name.includes(
                          "AITU Excelence Test"
                        )
                      ) {
                        return null;
                      }
                      if (
                        selectedAcademicDegree === 2 &&
                        englishCertificateType.name.includes("Foundation AITU")
                      ) {
                        return null;
                      }
                      if (
                        selectedAcademicDegree === 2 &&
                        englishCertificateType.name.includes("Олимпиада iQyn")
                      ) {
                        return null;
                      }
                      if (
                        selectedAcademicDegree === 2 &&
                        englishCertificateType.name.includes("Duolingo")
                      ) {
                        return null;
                      }
                      if (
                        selectedAcademicDegree === 1 &&
                        englishCertificateType.name.includes("GMAT")
                      ) {
                        return null;
                      }

                      return (
                        <MenuItem
                          key={englishCertificateType.id}
                          value={englishCertificateType.id}
                        >
                          {englishCertificateType.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>

                {selectedEnglishCertificateType &&
                  selectedEnglishCertificateType !== 5 && (
                    <Grid item xs={12} md={8} lg={10}>
                      <FileUpload
                        helperText="Скан сертификата, подтверждающего знания английского языка"
                        fileType={Constants.FILE_TYPES.englishCertificate}
                        file={englishExamScan}
                        filePath={englishExamScanPath}
                        handleSetFileId={(fileId) => setEnglishExamScan(fileId)}
                        handleDelete={() => {
                          fetchData();
                        }}
                      />
                    </Grid>
                  )}
                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    type="number"
                    label="Результаты (баллы) экзамена на знание английского языка"
                    onChange={(e) => setEnglishCertificatePoints(e.target.value)}
                    value={englishCertificatePoints}
                    className={classes.txtField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                {selectedAcademicDegree === 1 && isCertificateValid(selectedEnglishCertificateType, englishCertificatePoints) && (
                  <>
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        fullWidth
                        select
                        variant="outlined"
                        label="Какой курс вы бы хотели пройти вместо английского языка"
                        className={classes.txtField}
                        onChange={(e) =>
                          setSelectedAdditionalCourse(e.target.value)
                        }
                        value={selectedAdditionalCourse}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {additionalCourses.map((additionalCourse) => (
                          <MenuItem
                            key={additionalCourse.id}
                            value={additionalCourse.id}
                          >
                            {additionalCourse.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    fullWidth
                    select
                    variant="outlined"
                    label="Выберите тип имеющегося у вас сертификата олимпийского призёра"
                    className={classes.englishCertificate}
                    onChange={(e) =>
                      setSelectedOlympiadCertificateType(e.target.value)
                    }
                    value={selectedOlympiadCertificateType}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {olympiadCertificateTypes.map((olympiadCertificateType) => {
                      // if (
                      //   state.selectedAcademicDegree === 2 &&
                      //   englishCertificateType.name.includes(
                      //     "AITU Excelence Test"
                      //   )
                      // ) {
                      //   return null;
                      // }
                      // if (
                      //   state.selectedAcademicDegree === 2 &&
                      //   englishCertificateType.name.includes("Foundation AITU")
                      // ) {
                      //   return null;
                      // }
                      // if (
                      //   state.selectedAcademicDegree === 2 &&
                      //   englishCertificateType.name.includes("Олимпиада iQyn")
                      // ) {
                      //   return null;
                      // }
                      // if (
                      //   state.selectedAcademicDegree === 2 &&
                      //   englishCertificateType.name.includes("Duolingo")
                      // ) {
                      //   return null;
                      // }
                      // if (
                      //   state.selectedAcademicDegree === 1 &&
                      //   englishCertificateType.name.includes("GMAT")
                      // ) {
                      //   return null;
                      // }

                      return (
                        <MenuItem
                          key={olympiadCertificateType.id}
                          value={olympiadCertificateType.id}
                        >
                          {olympiadCertificateType.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>

                {selectedOlympiadCertificateType && (
                  <Grid item xs={12} md={8} lg={10}>
                    <FileUpload
                      helperText="Скан сертификаты призёра AITU iCode, AITU Open, Жаутыковской или Евразийской олимпиады"
                      fileType={Constants.FILE_TYPES.olympiadCertificate}
                      file={olympiadCertificateScan}
                      filePath={olympiadCertificateScanPath}
                      handleSetFileId={(fileId) =>
                        setOlympiadCertificateScan(fileId)
                      }
                      handleDelete={() => {
                        fetchData();
                      }}
                    />
                  </Grid>
                )}
                {(selectedEnglishCertificateType ||
                  selectedOlympiadCertificateType) && (
                    <Alert
                      variant="outlined"
                      severity="warning"
                      className={classes.infoAlert}
                    >
                      Напоминаем, что подделка документов преследуется по закону
                      РК
                    </Alert>
                  )}

                <Grid item xs={12} md={8} lg={10}>
                  <Grid container justify="center">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      disabled={isApproved}
                    >
                      Сохранить
                    </Button>
                  </Grid>
                </Grid>

                <Typography color="error">{errorMessage}</Typography>

                <Typography color="primary">{selectedCombinedExam}</Typography>
              </Grid>
            </form>
          </Paper>
        </>
      )}
    </>
  );
}

export default withServices()(ExamRegistration);
